// Shared constants for analytic report filters (ENG-1417 / ENG-1513).

// Sentinel a tag box filter list may contain, meaning "rows with no value in
// this column" (e.g. cases with no client organization). Must match
// UNASSIGNED_FILTER_VALUE in monolith-api src/services/reports/filter-utils.ts.
export const UNASSIGNED_FILTER_VALUE = "__unassigned__";

// report_parameters key holding the names of filters the user explicitly
// selected every option for. Those filters store no values (the query is
// unfiltered, so values added later are included); the marker only tells the
// edit form to seed the tag box fully checked. A field with no values and no
// marker is the default: also unfiltered, but the edit form shows it blank.
export const ALL_SELECTED_FILTERS_KEY = "all_selected_filters";

// Builds the option entry for an unassigned sentinel row in a tag box whose
// items are plain lookup objects (valueExpr fields). `valueField` is the tag
// box's valueExpr; the display label is resolved by the form's displayExpr
// function via displayWithUnassigned.
export const unassignedOption = (valueField) => ({
  [valueField]: UNASSIGNED_FILTER_VALUE,
});

// Builds the sentinel entry for the user object tag boxes (no valueExpr;
// values are objects keyed by user_id).
export const unassignedUserOption = (label) => ({
  user_id: UNASSIGNED_FILTER_VALUE,
  full_name: label,
});

// displayExpr helper: renders the sentinel row as its "(No ...)" label and
// every real option through its normal display field.
export const displayWithUnassigned = (displayField, label) => (item) =>
  item?.[displayField] === UNASSIGNED_FILTER_VALUE
    ? label
    : item?.[displayField];
